import React from 'react';
import GlobalBanner from './GlobalBanner';
import Markdown from 'react-markdown';

export default function FeatureFlagBanner(props: { shouldShow: boolean; message: string }) {
  const sanitizedBannerMessage = props.message?.replace(/\(([^)]+)\)/g, (match) => {
    const url = match?.slice(1, -1);
    try {
      // try to parse the url. If it is valid, return the banner message as is
      new URL(url);
      return match;
    } catch (error) {
      // if the url is invalid, add https:// to the start of the url
      return `(https://${url})`;
    }
  });

  const LinkRenderer = (props) => {
    return (
      <a href={props.href} target="_blank" rel="noreferrer">
        {props.children}
      </a>
    );
  };

  return props.shouldShow && <GlobalBanner message={<Markdown components={{ a: LinkRenderer }}>{sanitizedBannerMessage}</Markdown>} />;
}
